import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const FullscreenLoading = () => {
  return (
    <Spin spinning indicator={<LoadingOutlined rev="" style={{ fontSize: 48 }} spin />}>
      <div style={{ height: "100vh", width: "100vw" }} />
    </Spin>
  );
};

export default FullscreenLoading;
